'use client';

import { useBunja } from 'bunja/react';
import { Suspense, useState } from 'react';

import sparkCoinImage from '@flipster/features/assets/spark/reward/spark-coin.png';
import { useAuth } from '@flipster/features/src/shared/auth/state';
import { PortalContext, SparkRewardPage } from '@flipster/features/src/spark/reward';

import bannerPicture from '@web/app/[locale]/(web)/spark/reward/_assets/banner-nextjs';
import multiplyPicture from '@web/app/[locale]/(web)/spark/reward/_assets/multiply-nextjs';
import rewardPicture from '@web/app/[locale]/(web)/spark/reward/_assets/reward-nextjs';
import tradePicture from '@web/app/[locale]/(web)/spark/reward/_assets/trade-nextjs';
import { sparkRewardPageBunja } from '@web/app/[locale]/(web)/spark/reward/_bunja';
import {
  DepositCta,
  MultiplierCta,
  ShareCta,
  TermsAndConditionsCta,
  TradeCta,
} from '@web/app/[locale]/(web)/spark/reward/_page';

const Page = () => {
  const {
    userPointAtom,
    updatedAtAtom,
    earnedYesterdayAtom,
    multiplierRulesAtom,
    usdtBalanceAtom,
    percentilePointsAtom,
  } = useBunja(sparkRewardPageBunja);
  const { isLoggedIn } = useAuth();

  const [ended] = useState(() => new Date() > new Date('2025-01-12T00:00:00Z'));

  return (
    <Suspense>
      <PortalContext value='body'>
        <SparkRewardPage
          ended={ended}
          sparkCoinImageUrl={sparkCoinImage.src}
          banner={{ bannerPicture }}
          share={isLoggedIn ? { ShareCta } : undefined}
          summary={
            isLoggedIn
              ? {
                  ended,
                  DepositCta,
                  MultiplierCta,
                  userPointAtom,
                  updatedAtAtom,
                  earnedYesterdayAtom,
                  multiplierRulesAtom,
                  usdtBalanceAtom,
                }
              : undefined
          }
          ranking={isLoggedIn ? { userPointAtom, percentilePointsAtom } : undefined}
          trade={{ ended, TradeCta, tradePicture }}
          multiply={{ multiplyPicture }}
          reward={{ rewardPicture }}
          rules={{ TermsAndConditionsCta }}
        />
      </PortalContext>
    </Suspense>
  );
};

export default Page;
